import { computed, type Ref } from 'vue';

export const useComputedValue = <T extends Record<string, unknown>>(ref: Ref<T>, key: keyof T) =>
  computed({
    get() {
      return ref.value[key];
    },
    set(v) {
      ref.value[key] = v;
    },
  });
